import React from 'react';
import { OptionsObject, useSnackbar } from 'notistack';
import { AuthenticationResult } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { aquireToken } from './AuthContext';

export const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE'
};

const compileRoute = (route: string, params = null) => {
    if (params){
        const props: string[] = Object.getOwnPropertyNames(params);

        if (props && props.length > 0){
            route = `${route}?`
            props.filter(x => params[x] !== null && params[x] !== undefined).forEach(prop => route = `${route}${prop}=${params[prop]}&`);
            route = route.substr(0, route.length - 1);
        }        
    }

    return route;
};

export const ApiRoutes = {
    Graph: {
        GetMembers: (params) => compileRoute("/api/Graph/GetMembers", params),
        GetUsers: (params) => compileRoute("/api/Graph/GetUsers", params),
    },
    Role: {
        GetRoles: (params) => compileRoute("/api/Role/GetRoles", params),
        GetRole: (params) => compileRoute("/api/Role/GetRole", params),
    },
    User: {
        GetMe: (params) => compileRoute("/api/User/GetMe", params),
        GetUser: (params) => compileRoute("/api/User/GetUser", params),
        AddUserInRole: () => "/api/User/AddUserInRole",
        UpdateUserInRole: () => "/api/User/UpdateUserInRole",
        RemoveUserFromRole: (params) => compileRoute("/api/User/RemoveUserFromRole", params),
        AssignOwnerToProjectManager: () => "/api/User/AssignOwnerToProjectManager",
        GetProjectTeams: (params) => compileRoute("/api/User/GetProjectTeams", params),
        GetProjectTeam: (params) => compileRoute("/api/User/GetProjectTeam", params),
        GetMyProjectTeam: (params) => compileRoute("/api/User/GetMyProjectTeam", params),
        SaveProjectTeam: () => "/api/User/SaveProjectTeam",
        DeleteProjectTeam: (params) => compileRoute("/api/User/DeleteProjectTeam", params),
        GetUserSettings: (params) => compileRoute("/api/User/GetUserSettings", params),
        SaveUserSettings: (params) => compileRoute("/api/User/SaveUserSettings", params)
    },
    Budget: {
        GetBudgetSessions: (params) => compileRoute("/api/Budget/GetBudgetSessions", params),
        GetBudgetYears: (params) => compileRoute("/api/Budget/GetBudgetYears", params),
        GetBudgetYear: (params) => compileRoute("/api/Budget/GetBudgetYear", params),
        AddNewBudgetYear: () => "/api/Budget/AddNewBudgetYear",
        ActivateBudgetYear: () => "/api/Budget/ActivateBudgetYear",
        AdvanceBudgetYear: () => "/api/Budget/AdvanceBudgetYear",
        DeleteBudgetYear: (params) => compileRoute("/api/Budget/DeleteBudgetYear", params),
    },
    File: {
    Upload: () => "/api/File/Upload"
    },
    Data: {
    GetLookupData: (params) => compileRoute("/api/Data/GetLookupData", params)
    },
    Projects: {
    GetProjectsAmount: (params) => compileRoute("/api/Project/GetProjectsAmount", params),
    GetProjects: (params) => compileRoute("/api/Project/GetProjects", params),
    GetProject: (params) => compileRoute("/api/Project/GetProject", params),
    GetProjectSnapshot: (params) => compileRoute("/api/Project/GetProjectSnapshot", params),
    SaveProjects: () => "/api/Project/SaveProjects",
    RestoreProject: (params) => compileRoute("/api/Project/RestoreProject", params),
    SetProjectIsLocked: (params) => compileRoute("/api/Project/SetProjectIsLocked", params),
    CloneProjectsToNextYear: (params) => compileRoute("/api/Project/CloneProjectsToNextYear", params),
    ImportProjectsValues: () => "/api/Project/ImportProjectsValues",
    GetSpecularProjects: (params) => compileRoute("/api/Project/GetSpecularProjects", params),
    GetSapProjects: (params) => compileRoute("/api/Project/GetSapProjects", params),
    GetBwProjects: (params) => compileRoute("/api/Project/GetBwProjects", params),
    GetMilestones: (params) => compileRoute("/api/Project/GetMilestones", params),
    GetMilestone: (params) => compileRoute("/api/Project/GetMilestone", params),
    SaveMilestones: () => "/api/Project/SaveMilestones",
    SaveMilestone: () => "/api/Project/SaveMilestone",
    DeleteMilestone: (params) => compileRoute("/api/Project/DeleteMilestone", params),
    },
    Report: {
        GetReportLinks: (params) => compileRoute("/api/Report/GetReportLinks", params),
        GetReportLink: (params) => compileRoute("/api/Report/GetReportLink", params),
        AddNewReportLink: () => "/api/Report/AddNewReportLink",
        UpdateReportLink: () => "/api/Report/UpdateReportLink",
        DeleteReportLink: (params) => compileRoute("/api/Report/DeleteReportLink", params)
    },
    Dimension: {
        GetTableDefinitions: () => "/api/Data/GetTableDefinitions",
        GetTableValues: (params) => compileRoute("/api/Data/GetTableValues", params),
        UpdateDomains: () => compileRoute("/api/Data/UpdateDomain"),
        UpdateDigitals: () => compileRoute("/api/Data/UpdateDigital"),
        UpdateTargets: () => compileRoute("/api/Data/UpdateTarget"),
        UpdateCustomers: () => compileRoute("/api/Data/UpdateCustomer"),
        UpdateGoals: () => compileRoute("/api/Data/UpdateGoal"),
        UpdateNatures: () => compileRoute("/api/Data/UpdateNature"),
        UpdateInvestmentMixes: () => compileRoute("/api/Data/UpdateInvestmentMix"),
        UpdateMandatories: () => compileRoute("/api/Data/UpdateMandatory"),
        UpdateMethodologies: () => compileRoute("/api/Data/UpdateMethodology"),
        UpdateProjectApprovals: () => compileRoute("/api/Data/UpdateProjectApproval"),
        UpdateProjectPhases: () => compileRoute("/api/Data/UpdateProjectPhase"),
        UpdateProjectLives: () => compileRoute("/api/Data/UpdateProjectLife"),
        UpdateRebillings: () => compileRoute("/api/Data/UpdateRebilling"),
        UpdateReleaseDates: () => compileRoute("/api/Data/UpdateReleaseDate"),
        UpdateControllingAreas: () => compileRoute("/api/Data/UpdateControllingArea"),
        UpdateSubCustomers: () => compileRoute("/api/Data/UpdateSubCustomer"),
        UpdateSubDomains: () => compileRoute("/api/Data/UpdateSubDomain"),
        UpdateTimings: () => compileRoute("/api/Data/UpdateTiming"),
        UpdateMilestonePhases: () => compileRoute("/api/Data/UpdateMilestonePhase"),
        UpdateMilestoneStates: () => compileRoute("/api/Data/UpdateMilestoneStatus"),
        UpdateProjectStates: () => compileRoute("/api/Data/UpdateProjectStatus"),
        UpdatePortfolioMixes: () => compileRoute("/api/Data/UpdatePortfolioMix"),
        UpdatePriorities: () => compileRoute("/api/Data/UpdatePriority"),
        UpdateResponsibilityCenters: () => compileRoute("/api/Data/UpdateResponsibilityCenter"),

        DeleteDomains: () => "/api/Data/DeleteDomain",
        DeleteDigitals: () => "/api/Data/DeleteDigital",
        DeleteTargets: () => "/api/Data/DeleteTarget",
        DeleteCustomers: () => "/api/Data/DeleteCustomer",
        DeleteGoals: () => "/api/Data/DeleteGoal",
        DeleteNatures: () => compileRoute("/api/Data/DeleteNature"),
        DeleteInvestmentMixes: () => compileRoute("/api/Data/DeleteInvestmentMix"),
        DeleteMandatories: () => compileRoute("/api/Data/DeleteMandatory"),
        DeleteMethodologies: () => compileRoute("/api/Data/DeleteMethodology"),
        DeleteProjectApprovals: () => compileRoute("/api/Data/DeleteProjectApproval"),
        DeleteProjectPhases: () => compileRoute("/api/Data/DeleteProjectPhase"),
        DeleteProjectLives: () => compileRoute("/api/Data/DeleteProjectLife"),
        DeleteRebillings: () => compileRoute("/api/Data/DeleteRebilling"),
        DeleteReleaseDates: () => compileRoute("/api/Data/DeleteReleaseDate"),
        DeleteControllingAreas: () => compileRoute("/api/Data/DeleteControllingArea"),
        DeleteSubCustomers: () => compileRoute("/api/Data/DeleteSubCustomer"),
        DeleteSubDomains: () => compileRoute("/api/Data/DeleteSubDomain"),
        DeleteTimings: () => compileRoute("/api/Data/DeleteTiming"),
        DeleteMilestonePhases: () => compileRoute("/api/Data/DeleteMilestonePhase"),
        DeleteMilestoneStates: () => compileRoute("/api/Data/DeleteMilestoneStatus"),
        DeleteProjectStates: () => compileRoute("/api/Data/DeleteProjectStatus"),
        DeletePortfolioMixes: () => compileRoute("/api/Data/DeletePortfolioMix"),
        DeletePriorities: () => compileRoute("/api/Data/DeletePriority"),
        DeleteResponsibilityCenters: () => compileRoute("/api/Data/DeleteResponsibilityCenter"),

        AddDomains: () => "/api/Data/CreateDomain",
        AddDigitals: () => "/api/Data/CreateDigital",
        AddTargets: () => "/api/Data/CreateTarget",
        AddCustomers: () => "/api/Data/CreateCustomer",
        AddGoals: () => "/api/Data/CreateGoal",
        AddNatures: () => compileRoute("/api/Data/CreateNature"),
        AddInvestmentMixes: () => compileRoute("/api/Data/CreateInvestmentMix"),
        AddMandatories: () => compileRoute("/api/Data/CreateMandatory"),
        AddMethodologies: () => compileRoute("/api/Data/CreateMethodology"),
        AddProjectApprovals: () => compileRoute("/api/Data/CreateProjectApproval"),
        AddProjectPhases: () => compileRoute("/api/Data/CreateProjectPhase"),
        AddProjectLives: () => compileRoute("/api/Data/CreateProjectLife"),
        AddRebillings: () => compileRoute("/api/Data/CreateRebilling"),
        AddReleaseDates: () => compileRoute("/api/Data/CreateReleaseDate"),
        AddControllingAreas: () => compileRoute("/api/Data/CreateControllingArea"),
        AddSubCustomers: () => compileRoute("/api/Data/CreateSubCustomer"),
        AddSubDomains: () => compileRoute("/api/Data/CreateSubDomain"),
        AddTimings: () => compileRoute("/api/Data/CreateTiming"),
        AddMilestonePhases: () => compileRoute("/api/Data/CreateMilestonePhase"),
        AddMilestoneStates: () => compileRoute("/api/Data/CreateMilestoneStatus"),
        AddProjectStates: () => compileRoute("/api/Data/CreateProjectStatus"),
        AddPortfolioMixes: () => compileRoute("/api/Data/CreatePortfolioMix"),
        AddPriorities: () => compileRoute("/api/Data/CreatePriority"),
        AddResponsibilityCenters: () => compileRoute("/api/Data/CreateResponsibilityCenter"),            
    },
    GlobalSettings:{
        GetGlobalSettings: () => "/api/GlobalSetting/GetGlobalSettings",
        SetGlobalSetting: (params) => compileRoute("/api/GlobalSetting/SetGlobalSetting", params),
    }
};

export const FetchContext = React.createContext(null);

export const FetchProvider = ({ ...props }) => {
    const { instance } = useMsal();
    const { enqueueSnackbar } = useSnackbar();
    const snackOptions: OptionsObject = { variant: "error", autoHideDuration: 5000 };

    const createError = (code, message): Error => {
        const error = new Error(message);
        error.cause = code;
        return error;
    }

    // source: https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    const fetchRetry = (retries, api, cfg) =>
        fetch(api, cfg)
            .catch((error) => {
                if (retries === 1)
                    throw error;

                return fetchRetry(api, cfg, retries - 1);
            });

    const fetchAuthorized = async (api, cfg): Promise<Response> => {
        const response: AuthenticationResult = await aquireToken(instance);
        const accessToken: string = response.accessToken;

        if (cfg.headers) {
            if (cfg.body && (typeof cfg.body === 'string' || cfg.body instanceof String))
                cfg.headers["Content-Type"] = "application/json";
            
            cfg.headers["Cache-Control"] = "no-cache";
            cfg.headers["Pragma"] = "no-cache";            
            cfg.headers["Expires"] = "0";
            cfg.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        else {
            cfg = {
                ...cfg,
                cache: 'no-cache',
                headers: new Headers({
                    "Content-Type": `application/json`,
                    "Cache-Control": "no-cache",                    
                    "Pragma": "no-cache",
                    "Expires": "0",
                    "Authorization": `Bearer ${accessToken}`
                })
            };
        }

        return fetch(api, cfg)
            .then((r: Response): Response | Promise<never> => {
                if (r.ok)
                    return r;
                else {
                    switch (r.status) {
                        // Bad Request
                        case 400:
                            return r.json()
                                .then(data => {
                                    if (data.errors) {
                                        const errorKeys = Object.keys(data.errors);
                                        if(cfg.collectErrorDetails) {
                                            const error = new Error("Invalid data supplied");
                                            error.stack = JSON.stringify(errorKeys.map(x => ({ errorId: x,  message: data.errors[x][0]})));
                                            error.cause = r.status;
                                            return Promise.reject(error);
                                        } else {
                                            errorKeys.forEach(errorKey => {
                                                const error = data.errors[errorKey][0];                                            
                                                enqueueSnackbar(error, snackOptions);
                                            });
                                        }
                                    }
                                    return Promise.reject(createError(r.status, "Invalid data supplied"));
                                });
                        // Unauthorized
                        case 401:
                            return Promise.reject(createError(r.status, "User is not authorized"));
                        // Forbidden
                        case 403:                         
                            return Promise.reject(createError(r.status, "User is not allowed"));
                        // Not Found
                        case 404:
                            return Promise.reject(createError(r.status, "Resource not found"));
                        // Server Error
                        case 500:
                            return r.json()
                                .then(data => {
                                    let message = null;
                                    if (data.message) message = data.message;
                                    else message = "An internal error occured";
                                    return Promise.reject(createError(r.status, message));
                                });
                        // Not handled
                        default:
                            return Promise.reject(createError(r.status, "Something went bad"));
                    }
                }
            })
            .catch(error => {
                if(!cfg.suppressErrorMessage)
                    enqueueSnackbar(error.message, snackOptions);
                return Promise.reject(error);
            });
    };

    const { Provider } = FetchContext;

    return (
        <Provider value={{
            fetchRetry,
            fetchAuthorized
        }}>
            {props.children}
        </Provider>
    );
}